import { ProcessingOverlay } from '@components'

import { BorderRadius, Color } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from './styles'

export const InvoiceEditorProcessingOverlay = (): ReactElement => {
  return (
    <>
      {/* Added extra background to mimic ProcessingOverlay's since it's lost when position absolute becomes sticky */}
      <Styled.InvoiceEditorContentProcessingOverlayBackground />
      <ProcessingOverlay borderRadius={BorderRadius.R12} color={Color.White} isSticky withAnimation />
    </>
  )
}
